import { schemes, zSchema } from "@zeal/common";

const browserFileSchema =
  typeof File === "undefined" ? zSchema.any() : zSchema.instanceof(File);

export const postPartnerUBODocumentParamsSchema = zSchema.object({
  whiteLabelID: schemes.uuid(),
  ubo_document: browserFileSchema,
  first_name: zSchema.string(),
  last_name: zSchema.string(),
});

export type TPostPartnerUBODocumentParams = zSchema.infer<
  typeof postPartnerUBODocumentParamsSchema
>;

export const postPartnerUBODocumentResponseSchema = zSchema.object({
  success: zSchema.boolean(),
  message: zSchema.string(),
});

export type TPostPartnerUBODocumentResponse = zSchema.infer<
  typeof postPartnerUBODocumentResponseSchema
>;
